import { render, staticRenderFns } from "./CasesItem.vue?vue&type=template&id=2fe46553&scoped=true&"
import script from "./CasesItem.vue?vue&type=script&lang=js&"
export * from "./CasesItem.vue?vue&type=script&lang=js&"
import style0 from "./CasesItem.vue?vue&type=style&index=0&id=2fe46553&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe46553",
  null
  
)

export default component.exports